<template>
  <div class="vx-card">
    <div class="vx-card__body">
      <form>
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <vs-input
              :placeholder="$t('user_displayName')"
              v-model="user_displayName"
              name="user_displayName"
              :label="$t('Creator')"
              readonly="readonly"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-2">
            <label class="vs-select--label">{{ $t("WarehouseName") }}</label>
            <v-select
              class="m-0"
              label="name"
              name="warehouse"
              :options="allWarehouses"
              v-model="checkInModel.storeId"
              v-validate="{ required: true }"
              :reduce="(x) => x.id"
              :disabled="setDisabled"
              dir="rtl"
              :loading="warehousesLoading"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('warehouse')"
              >{{ errors.first("warehouse") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-1">
            <label class="vs-select--label datepicker-lb">{{
              $t("CreationDate")
            }}</label>
            <date-picker
              v-model="checkInModel.registerClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              id="date-picker"
              :label="$t('CreationDate')"
              :disabled="setDisabled"
              name="date"
            />
            <span class="text-danger text-sm" v-show="errors.has('date')">{{
              errors.first("date")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-2">
            <vs-input
              class="inputx"
              v-model="checkInModel.automationCode"
              name="automationCode"
              :disabled="setDisabled"
              v-validate="'required'"
              :label="$t('AutomationCode')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('automationCode')"
              >{{ errors.first("automationCode") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <vs-input
              class="inputx"
              v-model="checkInModel.cottageNumber"
              name="cottageNumber"
              :disabled="setDisabled"
              v-validate="'required'"
              maxlength="16"
              :label="$t('CottageNumber')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('cottageNumber')"
              >{{ errors.first("cottageNumber") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-2">
            <vs-input
              class="inputx"
              v-model="checkInModel.shipmentNumber"
              name="shipmentNumber"
              :disabled="setDisabled"
              v-validate="'required'"
              maxlength="16"
              :label="$t('ShipmentNumber')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('shipmentNumber')"
              >{{ errors.first("shipmentNumber") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/2 sm:w-full mt-2">
            <vs-input
              class="w-full"
              v-model="checkInModel.description"
              :disabled="setDisabled"
              rows="1"
              :label="$t('Description')"
            />
          </div>
          <div class="w-full vx-col mt-8">
            <vs-button
              type="filled"
              class="float-right px-12"
              @click.prevent="submitInformationGeneral()"
              v-show="!setDisabled"
              >{{ $t("Continue") }}</vs-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "@/components/CustomVSelect.vue";
import { Validator } from "vee-validate";
import * as moment from "jalali-moment";
import authService from "../../../auth/authService";

const dict = {
  custom: {
    warehouse: {
      required: "لطفا نام انبار را انتخاب نمایید.",
    },
    date: {
      required: "لطفا تاریخ ثبت را انتخاب نمایید.",
    },
    automationCode: {
      required: "لطفا کد اتوماسیون را وارد نمایید.",
    },
    cottageNumber: {
      required: "لطفا شماره کوتاژ را وارد نمایید.",
    },
    shipmentNumber: {
      required: "لطفا شماره شیپمنت را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_Cardex_Index",
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
  },
  data() {
    return {
      user_displayName: "",
      setDisabled: false,
      checkInModel: {
        storeId: null,
        requesterInfoCommand: { requesterId: "1", requesterName: "Admin" },
        registerClock: "",
        automationCode: null,
        description: "",
        cottageNumber: null,
        shipmentNumber: null,
        inventoryTransactionItemCommands: [],
      },
      listOfShelvesRelated1: [],
      warehousesLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/listWithShelves",
    }),
  },
  mounted() {
    this.get_displayName();
    this.fetchWarehouses().then(() => {
      this.warehousesLoading = false;
    });
    this.calcCurrentTime();
  },
  methods: {
    async get_displayName() {
      var userInfo = await authService.getUser();
      this.user_displayName = userInfo.profile.nickname;
    },
    ...mapActions({
      fetchWarehouses: "warehouse/fetchList",
    }),
    calcCurrentTime() {
      let todayJalali = moment().locale("fa").format("YYYY-M-D hh:mm:ss");
      this.checkInModel.registerClock = todayJalali;
    },
    submitInformationGeneral() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var Sid = this.checkInModel.storeId;
          var warhouseArr = this.allWarehouses;
          let selectedWarhouse = warhouseArr.find(
            (selectedWarhouse) => selectedWarhouse.id == Sid
          );
          this.listOfShelvesRelated1 = selectedWarhouse.shelveQueries;
          this.checkInModel.storeName = selectedWarhouse.name;
          this.checkInModel.cottageNumber = Number(
            this.checkInModel.cottageNumber
          );
          this.setDisabled = true;
          this.$emit(
            "sendDataToBasePageCreate",
            this.listOfShelvesRelated1,
            this.checkInModel
          );
        }
      });
    },
  },
};
</script>
